import React, { useState, useEffect } from 'react';
import './buynow.css';
import { Divider } from '@mui/material';
import Option from './Option';
import Subtotal from './Subtotal';
import { useCart, useDispatchCart } from '../contextreducer/ContextReducer';
import Empty from './Empty';
import CircularProgress from '@mui/material/CircularProgress';
import {useNavigate  } from 'react-router-dom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function Buynow() {

  const useremail = localStorage.getItem("userEmail");

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true);
  const data = useCart();
  const dispatch = useDispatchCart()
  const [quantities, setQuantities] = useState(data.map((item) => item.quantity)); // Initialize quantities with an array of 1s

  const handleQuantityChange = (index, e) => {
    const newQuantities = [...quantities];
    newQuantities[index] = parseInt(e.target.value);
    setQuantities(newQuantities);

    const existingItem =  data.find((item, i) => i === index);
    if (existingItem) {
    const updatedItem = {
      ...existingItem,
      quantity: newQuantities[index],
    };
    dispatch({
      type: "UPDATE",
      item: updatedItem,
    });
  }
  };

  const totalPrice = data.reduce((total, item, index) => total + item.price * quantities[index], 0);
  console.log(totalPrice);

  useEffect(() => {
    // Simulating an asynchronous data fetch
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);


  const handleClickcheckout = () => {
    dispatch({ type: 'SET_TOTAL_PRICE', totalPrice: totalPrice });
    navigate('/checkout');
  };

  const handleClicksignin = () => {
    navigate('/login');
  };

  if (isLoading) {
    return (
      <div className="cart_section">
        <div className="circle">
          <CircularProgress />
          <h2>Loading....</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="buynow_section">
      <div className="buynow_container">
        <div className="left_buy">
          <h1>Shopping Cart</h1>
          <p>Select all items</p>
          <span className="leftbuyprice">Price</span>
          {data.length > 0 ? (
            <>
              <Divider />
              {data.map((item, index) => (
                <div className="item_containert" key={index}>
                  <img src={item.img} alt="imgitem" />
                  <div className="item_details">
                    <h5>{item.shortTitle}</h5>
                    <h5>{item.longTitle}</h5>
                    <p className="unusuall">Usually dispatched in 8 days.</p>
                    <p>Eligible for FREE Shipping</p>
                    <img
                      src="https://m.media-amazon.com/images/G/31/marketing/fba/fba-badge_18px-2x._CB485942108_.png"
                      alt="logo"
                    />
                    <div className="add_remove_select">
                      <select
                        className="form-select"
                        value={quantities[index]} // Use individual quantity from quantities array
                        onChange={(e) => handleQuantityChange(index, e)}
                      >
                        {Array.from(Array(10), (e, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                      <Option ind={index} />
                    </div>
                  </div>
                  <h4 className="item_price">₹{item.price * quantities[index]}</h4> {/* Use individual quantity from quantities array */}
                </div>
              ))}
              <Divider />
            </>
          ) : (
            <p>
              <Empty />
            </p>
          )}
          <Subtotal price={totalPrice} />
        </div>
        <div className="right_buy">
          <img src="https://images-eu.ssl-images-amazon.com/images/G/31/checkout/assets/TM_desktop._CB443006202_.png" alt="rightimg" />
          <div className="cost_right">
            <p>Your order is eligible for FREE Delivery. <br />
              <span style={{ color: "#565959" }}> Select this option at checkout. Details</span></p>
            <h5>Subtotal ({data.length} item): <span style={{ fontWeight: "700" }}> ₹{totalPrice}</span></h5>
            {useremail ?
              <button className={`rightbuy_btn ${data.length === 0 ? 'disabled' : ''}`} 
              onClick={handleClickcheckout}
              disabled={data.length === 0}
              >checkout</button>
              :
              <button className="rightbuy_btn" onClick={handleClicksignin}>Signin</button>
             }
            <div className="emi">
              Emi available
              <KeyboardArrowUpIcon />
              {/* <KeyboardArrowDownIcon /> */}
            </div>
            <span className="hide" > Your order qualifies for EMI with valid credit cards (not available on purchase of Gold,
                  Jewelry, Gift cards and Amazon pay balance top up). Learn more</span>
          </div>
        </div>
      </div>
    </div>
  );
}
